import {Component, ViewChild, OnInit} from '@angular/core';
import { environment } from '../../environments/environment';
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { DateAdapter } from '@angular/material';
import { AuthService } from "../auth.service";
import "rxjs/Rx";
import { Subject }    from 'rxjs/Subject';
import { SharedModule, NumPipe, UtilsService } from "../shared/shared.module";

declare let swal:any;

@Component({
  selector: 'app-validate-campaign',
  templateUrl: './validate-campaign.component.html',
  styleUrls: ['./validate-campaign.component.css']
})
export class ValidateCampaignComponent implements OnInit {

  environment: any;

  isLoading: boolean = false;
  pharmaCampaign: any = {
    pharmacy: [],
    campaign: {
      questions: []
    }
  };
  search: string = '';
  campaignId:number;
  sortBy: string = 'status_priority';
  revert: boolean = true;
  page: number = 1;
  totalPage: number = 1;


  constructor(
    private numPipe: NumPipe,
    private authService: AuthService,
    private http: HttpClient,
    private utilsService: UtilsService,
    private router: Router,
    private route: ActivatedRoute,
    private dateAdapter: DateAdapter<Date>
  ) {
    this.dateAdapter.setLocale('fr');
  }

  ngOnInit() {
    this.environment = environment;
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      this.utilsService.scrollTop();
    });

    this.route.params.subscribe(params => {
      if (params.id)
        this.campaignId = parseInt(params.id);
      if (params.sort)
        this.sortBy = params.sort;
      if (params.revert)
        this.revert = (params.revert == 'true');
      if (params.page)
        this.page = parseInt(params.page);
      if (params.search)
        this.search = params.search;
      if (this.campaignId) {
        this.getCampaign();
      }
      else {
        this.utilsService.displayNotif("Cette campagne n'existe pas", "danger");
        this.router.navigate(['../..'], {relativeTo: this.route});
      }
    });
  }

  getCampaign() {
    this.isLoading = true;
    var query = "?page=" + this.page + "&sortBy=" + this.sortBy + "&revert=" + this.revert + "&search=" + this.search;
    if (this.authService.connectedAs.admin == false)
      query += "&connectedAsId=" + this.authService.connectedAs.id;
    this.http.get(environment.API_PATH + '/campaign/' + this.campaignId + '/details/response' + query, {withCredentials: true})
	  .subscribe(
      data => {
        this.isLoading = false;
        this.totalPage = data['count'];
        this.pharmaCampaign = data['rows'];
      },
      err => {
        this.isLoading = false;
        var errors = err.error;
        if (errors.error) {
          if (errors.error.status === 401) {

            this.router.navigate(['/connexion']);
          } else if (errors.error.status === 403) {
            if (errors.error.details.redirect)
              this.router.navigate([errors.error.details.redirect]);
            else
              this.router.navigate(['connexion']);
          } else {
            this.utilsService.displayNotif("Une erreur est survenue, merci de réessayer", "danger");
          }
        } else {
          this.utilsService.displayNotif("Une erreur est survenue, merci de réessayer", "danger");
        }
      });
  }

  changePage(num) {
    this.router.navigate(['administration','campagnes','validation', this.campaignId, this.sortBy, this.revert, this.page + num, this.search]);
  }

  goToCampaign() {
    this.router.navigate(['administration', 'campagnes' ,'recapitulatif', this.campaignId]);
  }

  confirmAccept() {
    swal({
      title: 'Êtes-vous sûr de vouloir accepter la campagne de la pharmacie "' + this.pharmaCampaign.pharmacy.name + '" ?',
      html:
      '<div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12" >' +
      '<label>' +
      '<span>Commentaire (optionel)</span>' +
      '</label>' +
      '<textarea id="accepted_reason" class="form-control long_desc_area" placeholder="Commentaire"></textarea>' +
      '</div>',
      type: 'warning',
      showCancelButton: true,
      reverseButtons: true,
      confirmButtonColor: '#49B0D6',
      cancelButtonColor: '#E74C3C',
      cancelButtonText: 'Non',
      confirmButtonText: 'Oui'
    }).then(() => {
      var reason = document.getElementById('accepted_reason')['value'];
      this.acceptCampaign(reason)
    }, () => {

    });
  }

  acceptCampaign(reason) {
		this.isLoading = true;
		this.http.post(environment.API_PATH + '/campaign/pharmacy_campaign/validate' , {id: this.pharmaCampaign.id, reason: reason}, {withCredentials: true})
		.subscribe(
      data => {
        this.isLoading = false;
        this.getCampaign();
      },
      err => {
        this.isLoading = false;
        if (err.status === 401) {

          this.router.navigate(['/connexion']);
        } else if (err.status === 404) {
          this.utilsService.displayNotif("Cette campagne n'existe pas", "danger");
          this.router.navigate(['../..'], {relativeTo: this.route});
        } else {
          this.utilsService.displayNotif("Une erreur est survenue, merci de réessayer", "danger");
        }
      });
  }
  confirmRefuse(): void {
    swal({
      title: 'Êtes-vous sûr de vouloir refuser la campagne de la pharmacie "' + this.pharmaCampaign.pharmacy.name + '" ?',
      html:
      '<div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12" >' +
        '<label>' +
          '<span>Raison du refus</span>' +
        '</label>' +
        '<textarea id="refused_reason" class="form-control long_desc_area" placeholder="Raison du refus"></textarea>' +
      '</div>',
      type: 'warning',
      showCancelButton: true,
      reverseButtons: true,
      confirmButtonColor: '#49B0D6',
      cancelButtonColor: '#E74C3C',
      cancelButtonText: 'Non',
      confirmButtonText: 'Oui'
    }).then(() => {
      var reason = document.getElementById('refused_reason')['value'];
      this.refuseCampaign(reason)
    }, () => {

    });
  }

  refuseCampaign(reason) {
    this.isLoading = true;
    this.http.post(environment.API_PATH + '/campaign/pharmacy_campaign/refuse' , {id: this.pharmaCampaign.id, reason: reason}, {withCredentials: true})
		.subscribe(
      data => {
        this.isLoading = false;
        this.getCampaign();
      },
      err => {
        this.isLoading = false;
        if (err.status === 401) {

          this.router.navigate(['/connexion']);
        } else if (err.status === 404) {
          this.utilsService.displayNotif("Cette campagne n'existe pas", "danger");
          this.router.navigate(['..'], {relativeTo: this.route});
        } else {
          this.utilsService.displayNotif("Une erreur est survenue, merci de réessayer", "danger");
        }
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/validate-campaign/validate-campaign.component.ts